import { useAuth } from "@/hooks/useAuth";
import { useGetAccountByIdQuery } from "@/redux/api/accounts.rtkq";
import FeaturePreview from "@/components/FeaturePreview";
import { canUseApp } from "@/utils/appAccess";

const WORD_ADDON_APP_ID = "word-addon";
const INSTALL_VIDEO_URL = "https://www.youtube.com/watch?v=RRL0-s4GnbQ";

const KnowledgePage: React.FC = () => {
  const auth = useAuth();
  const accountId = auth.getAccountId();
  const { data: account, isSuccess, isLoading } = useGetAccountByIdQuery(
    { accountId: accountId! },
    { skip: !accountId },
  );

  if (!accountId || isLoading) {
    return (
      <div className="flex h-40 items-center justify-center">
        <div className="text-lg">טוען...</div>
      </div>
    );
  }

  if (isSuccess && !canUseApp(account, WORD_ADDON_APP_ID)) {
    return <FeaturePreview appId="word-addon" />;
  }

  return (
    <section
      className="mx-auto flex h-full max-w-xl flex-col justify-center gap-4 p-8 text-right"
      dir="rtl"
      aria-label="תוסף Word"
    >
      <h1 className="text-2xl font-semibold text-indigo-900">תוסף Word</h1>
      <p className="text-base leading-relaxed text-slate-600">
        התוכנית שלך כוללת את תוסף Legalix ל־Microsoft Word. העבודה על המסמך נעשית בתוך Word —
        לא בדף הזה.
      </p>
      <ol className="list-decimal space-y-2 pe-5 text-base leading-relaxed text-slate-700">
        <li>פתחו את Microsoft Word (שולחן עבודה או Word באינטרנט).</li>
        <li>
          בתפריט <span className="font-medium">Insert</span> /{" "}
          <span className="font-medium">הוספה</span> בחרו{" "}
          <span className="font-medium">Add-ins</span> /{" "}
          <span className="font-medium">תוספים</span> ←{" "}
          <span className="font-medium">Get Add-ins</span>.
        </li>
        <li>
          חפשו <span className="font-medium">Legalix</span>, התקינו את התוסף והתחברו עם אותו
          חשבון Legalix.
        </li>
      </ol>
      <p className="text-sm text-slate-500">
        מדריך וידאו:{" "}
        <a
          href={INSTALL_VIDEO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-indigo-600 underline"
        >
          התקנת תוסף Legalix ב־Word
        </a>
      </p>
    </section>
  );
};

export default KnowledgePage;
